import React from 'react';
import autobind from "autobind-decorator";

import { PureComponent } from 'core/components';
import { BlockTitle, Icon } from 'core/components/Framework7';
import { Toggle } from 'framework7-react';

import classes from './styles.module.css';

class Availability extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      availability: props.defaultChecked,
    }
  }

  static get defaultProps() {
    return {
      defaultChecked: false,
      availabilityText: "فقط کالاهای‌ موجود"
    }
  }

  changeAvailability() {
    const { availability } = this.state;

    this.setState({
      availability: !availability
    })

    this.props.availability(this.state.availability)
  }

  render() {
    const { availabilityText } = this.props;
    const { availability } = this.state;

    return (
      <div className={classes.toggleLabel}>
        <Toggle
          checked={availability}
          className={classes.toggle}
          onToggleChange={this.changeAvailability}
        />
        <span>{availabilityText}</span>
      </div>
    )
  }
}

export default autobind(Availability);
